import * as moment from "moment";
import * as htmlToText from 'html-to-text';

interface BHAssessment {
    phraseId: string,
    isICD10: boolean
    expiryDate: {
        year: number,
        month: number,
        day: number,
    },
    expiryDays: number
}
interface INote {
    _id?:string;
    title:string,
    htmlText:string;
    uploadedBy:{};
    provider:{};
    facility:{};
    patient:{};
    // state: {
    //     active:boolean,
    //     published:boolean,
    //     locked:boolean,
    //     signed:boolean,
    //     uploaded:boolean
    // }
    is_active: 'true'|'false';
    is_signed: 'true'|'false';
    is_draft: 'true'|'false';

    dates: {
        service: Date | any,

        creation: Date | any,

        sign: Date,

        upload: Date,

        timezone?:string
    };


    note_status: {
        status: 'in_progress'|'internal_qa'|'external_qa'|'published'|'signed',
        id: string|any; // 'owner_id'|'qa_internal_id'|'qa_external_id'|'provider_id'
    };
    coSign_status:{
        status,
        coSigned_to,
        coSigned_by,
    };
    coSigned_provider?:{
        _id,
        first_name,
        last_name,
        title
    }

    audio?:{};

    patient_id?:string;

    rounding_sheet_id?:string;

    edit_lock: {
        lockedOn: Date,
        userId: string
    }

    followUpNote?:{
        _id:string,
        data: {title: string, section: string}[];
    };
    lockedBy?: string,
    changeDateObj: {},
    bh_assessment_expiry: BHAssessment[]

}

export class Note implements INote {
    _id?:string;
    title: string;
    htmlText: string;
    uploadedBy: any;
    provider: any;
    facility: any;
    patient: any;
    date_obj: any;
    // state: { active: boolean; published: boolean; locked: boolean; signed: boolean; uploaded: boolean; };
    is_active: 'true'|'false';
    is_signed: 'true'|'false';
    is_draft: 'true'|'false';
    template_id_ref: any;
    dates: {
        service: Date | any,

        creation: Date | any,

        sign: Date,
        
        upload: Date,

        timezone?:string
    }


    note_status: {
        status,
        id
    }
    coSign_status:{
        status ,
        coSigned_to,
        coSigned_by
    }
    coSigned_provider?:{
        _id,
        first_name,
        last_name,
        title
    }

    audio?;

    pcc_progressNoteStrikeOut?;
    pcc_progressNoteId?;
    pcc_documentId?;

    patient_id?:string;

    rounding_sheet_id?:string;

    edit_lock: {
        lockedOn: Date,
        userId: string
    }

    followUpNote?:{
        _id:string,
        transcribtion_title?:string,
        data: {title: string, section: string}[];
    };
    lockedBy?: string
    phrasesUpdateNeeded?: boolean
    resolveTplEntities?: boolean
    changeDateObj: {}
    timeChangedObj: {}
    time_logs : any = {};
    bh_assessment_expiry: BHAssessment[] = []
    portal: string;

    constructor(note?) {
        this._id = note?._id || null;
        this.audio = note?.audio;
        this.title = note?.title ||  '';
        this.htmlText = note?.htmlText || '';
        this.dates = note?.dates || {
            service: new Date(),
            creation: new Date(),
            sign: null,
            upload: null,
        },
        this.uploadedBy = note?.uploadedBy;
        this.provider = note?.provider;
        this.facility = note?.facility;
        this.patient = note?.patient;
        // debugger
        if(this.patient && this.facility) {
            if(!this.patient.facility_id_ref) {
                this.patient.facility_id_ref = this.facility;
            }
        }
        this.date_obj = note?.date_obj;
        this.note_status = note?.note_status;
        this.coSign_status = note?.coSign_status; 
        this.coSigned_provider = note?.coSigned_provider; 
        this.is_signed = note?.is_signed;
        this.is_active = note?.is_active;
        this.is_draft = note?.is_draft;
        this.pcc_progressNoteStrikeOut = note?.pcc_progressNoteStrikeOut;
        this.pcc_progressNoteId = note?.pcc_progressNoteId;
        this.pcc_documentId = note?.pcc_documentId;
        this.patient_id = note?.patient_id;
        this.rounding_sheet_id = note?.rounding_sheet_id;
        this.edit_lock = note?.edit_lock;
        this.template_id_ref = note?.template_id_ref;
        this.followUpNote = note?.followUpNote;
        this.lockedBy = note?.lockedBy;
        this.phrasesUpdateNeeded = note?.phrasesUpdateNeeded;
        this.resolveTplEntities = note?.resolveTplEntities;
        this.bh_assessment_expiry = note?.bh_assessment_expiry || [];
        this.portal = note?.portal;
    }

    isInProgress(userId, relationship, assoc_provider_ids?) {
        if(!this._id || !this.note_status) return false;
        // return this.note_status.status === 'in_progress' && this.note_status.id === userId;
        return this.note_status.status === 'in_progress' && (
            relationship?.assoc_trancriber_id?.includes(userId) || 
            assoc_provider_ids?.includes(userId) || 
            this.uploadedBy == userId);
    }
    isInMAReview(userId, relationship) {
        if(!this._id || !this.note_status) return false;
        // return this.note_status.status === 'internal_qa' && this.note_status.id === userId;
        return ((this.note_status.status === 'in_progress' && relationship?.assoc_ma_ids?.includes(userId)) || (this.note_status.status === 'published' && relationship?.assoc_ma_ids?.includes(userId)));
    }

    isInQAIReview(userId, relationship) {
        if(!this._id || !this.note_status) return false;
        // return this.note_status.status === 'internal_qa' && this.note_status.id === userId;
        return this.note_status.status === 'internal_qa' && relationship.qa_id === userId;
    }

    isInQAEReview(userId, relationship) {
        if(!this._id || !this.note_status) return false;
        // return this.note_status.status === 'external_qa' && this.note_status.id === userId;
        return this.note_status.status === 'external_qa' && relationship.qa_e_id === userId;
    }

    isPublished(userId?, relationship?, assoc_provider_ids?) {
        if(!this._id || !this.note_status) return false;

        const isNotePublished = this.note_status.status === 'publish' || this.note_status.status === 'published';
        if(userId && relationship || userId && assoc_provider_ids) {
            // return isNotPublished && this.note_status.id === userId;
            return isNotePublished && (assoc_provider_ids?.includes(userId) || this.provider._id === userId || userId === this.coSign_status?.coSigned_to);
        } else {
            return isNotePublished &&  userId === this.coSign_status?.coSigned_to;
        }
    }
    
    isSigned() {
        if(!this._id || !this.note_status) return false;

        const isNotUploaded = this.note_status.status === 'not_uploaded' || this.is_signed === 'true';
        return isNotUploaded;
        // if(userId) {
        //     return isNotUploaded && this.note_status.id === userId;
        // } else {
        //     return isNotUploaded;
        // }
        // return this.is_signed === 'true';
    }

    isUploaded() {
        if(!this._id || !this.note_status) return false;
        return this.note_status.status === 'uploaded';
    }
    isUploadedToPCC() {
        if(!this._id || !this.note_status) return false;
        return !!this.pcc_progressNoteId || !!this.pcc_documentId;
    }

    
    hasPCCPatient() {
        if(!this._id || !this.note_status) return false;
        return !!this.patient?.pcc_patientId;
    }


        
    hasPCCPatientandDnFacility() {
        if(!this._id || !this.note_status) return false;
        if(this.patient?.pcc_patientId&&!this.facility.pcc_facId){
            return true;
        }else return false;
    }


    canCreateAddendum(userId) {
        return this.note_status.status === 'uploaded' && this.uploadedBy?._id === userId;
    }
    isInvalid() {
        if(!this.title) return "Title is required";
        const htmlText = htmlToText.fromString(this.htmlText, {
            wordwrap: 130,
            singleNewLineParagraphs: true
        }).trim();
        if(!htmlText) return "Note text is required";
        if(!moment(this.dates?.service).isValid()) return "Note DOS is required";
        if(!this.provider) return "Provider is required";
        if(!this.facility) return "Facility is required";
        if(!(this.patient && this.patient._id)) return "Patient is required";
        return false;
    }
    relation(userId, relationship, assoc_provider_ids) {
        return {
            owner: this.isInProgress(userId, relationship, assoc_provider_ids),
            isQAI: this.isInQAIReview(userId, relationship),
            isQAE: this.isInQAEReview(userId, relationship),
            provider: this.isPublished(userId),
        }
    }

    hasAudio() {
        return !!this.audio;
    }

    isRelatedProvider(user_id) {
        // user_id === this.note_status
        
        return this.provider?._id === user_id || user_id == this.coSign_status?.coSigned_to;
    }

    containsAsterisks(htmlText?) {
        const _htmlText = htmlText || this.htmlText;
        return _htmlText.match(/\*{3,}/) !== null
    }

    containsUnselectedDropdowns(htmlText?) {
        const _htmlText = htmlText || this.htmlText;

        const $temp = document.createElement('div');
        $temp.innerHTML = _htmlText;
        // query all spans with class select-dropdown and has no data-options-selected attribute
        const $dropdowns = $temp.querySelectorAll('span.select-dropdown:not([data-options-selected])');
        return $dropdowns.length > 0;
    }

    containsUnresolvedPhrases(dictionary, htmlText?) {
        if (!dictionary || !htmlText) {
            return false;
        }
        const phrases = dictionary.map(d => d.key);
        const _htmlText = htmlText || this.htmlText;
        const $temp = document.createElement('div');
        $temp.innerHTML = _htmlText;
        for (const phrase of phrases) {
            const phraseWithMarker = `.${phrase}`;
            if($temp.innerText.includes(phraseWithMarker)) {
                return true;
            }
        }
        return false;
    }
    
    isEditLocked(userId) {
        if(this.lockedBy) {
            return userId != this.lockedBy;
        }
        else return false;
    }
}
